import React from "react";
import { Link } from "react-router-dom";
import { slugify } from "../../../utils";

const PropOne = ({ projectStyle, portfolio }) => {
  return (
    <>
      <div className={`project-grid ${projectStyle}`}>
        <div className="thumbnail">
          <Link
            to={
              process.env.PUBLIC_URL +
              `/course-details/${slugify(portfolio.title)}`
            }
          >
            <img src={process.env.PUBLIC_URL + portfolio.image} alt="icon" />
          </Link>
        </div>
        <div className="content">
          <h4 className="title">
            <Link
              to={
                process.env.PUBLIC_URL +
                `/course-details/${slugify(portfolio.title)}`
              }
            >
              {portfolio.title}
            </Link>
          </h4>
             <p className="course-description">
          {portfolio.description.length > 100
            ? portfolio.description.substring(0, 100) + "..."
            : portfolio.description}
        </p>
        </div>
      </div>
    </>
  );
};

export default PropOne;
